export const TEMPLATE_KEYS = {
  DEFAULT: "default",
  JAPAN: "japan",
  AUSTRALIA: "australia",
};

export const PAGE_TEMPLATE_TYPES = {
  LOWCODE: "lowcode",
  COMPONENT: "component",
};

export default {
  TEMPLATE_KEYS,
  PAGE_TEMPLATE_TYPES,
};
